
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 35 30","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"35","height":"30","data-name":"Vector Smart Object","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAeCAQAAAAMNG+hAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLFzUxk7jJAAACsElEQVRIx6WUX2gVZBjGf2dz6v52mEbSmogXIlG4OTDJ4c7aOVnNxAt1KogycEpBVgTVTUwTugq76EIKIUoCJQiyxGkyh/hvsKlHncxN5tzmjG2HzZ0z2bnYrwunELWddva8Vx88PDzP833vh6SYHIfMTcXKIBXmUkhWKlJqmTGSvDIbmV0EgSS/UAMUsGsa7jSJhw2JZY5YJ4YcTq8bAdjNeb57dkojVDvlwHHCbAI6yGVFOjInqASauMha4AFXqZh5NytNuEf83G6Xip867Msz7+Z1evgJyOcRo0CYo7TN3M0Cr3tEzPGyX4shR3135m6G+J0XgDFgCGiim0XpvJt2t4t56mKx1DGDU3Gnk3nbXDGoBsV8103NTbXfON8Ws1OxMuv/mTGTal7jPuO8xRr6eEyI2/QSp5JKBhilnCpijPxXN9nWWSpG7PShbQ7Z7oBRR7xlzGuOetMRW0wYNW6zj/1exA/daOBpqICNdlooFrvJPAOG3eJzYoU1ForlbvN5cbXbXSSWTfb0iYMeeiqz0WELxRK/sctW9/qOv9nnKTdYa7P3PGylX9rhTT8y4s/et8nNFohlJn1VMMOo9WKB3f7hBt83ao+HjXjIe7b5sdX+ar+Nbnanzfb5oxH3e9f3RPzB0xJwK9+yhDhQTIg4Z4iTxzqyOUcvGVTxEq1cB0opoZtzTEwyGxgDXuQONXjLz8TlnjRpq10OetJBu7xq0gY7jHnBpJe8ZNILxuyw4RnzqFniF7bNYSlxFjJBI19xgwzeYBlHaGSCElZxnFMkKOJNpJZ+cqkmyEFuTPrMI4txirHGv5wd+lw/hzDbuM080sU4y9mB9SYsSrkSU0+RCQ8gtvjBLGT22fLkvzlLOO1IUMVZCAhr+JPV/1q2/4d8rhDm4hNjx2ZxT8dE/gb6EzKZS2MyzwAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    